import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Action buttons row container
 * Displayed between MainContentRow and ActionFooter in modal mode
 */
export const ActionButtonsRow = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  padding: '0 24px 16px 24px', // Left/right padding matches MainContentRow
  justifyContent: 'flex-end', // Align buttons to the right
  alignItems: 'center',
}) as typeof Box;
